/**
 * Capitalize the first character of a string.
 *
 * @param {String} str The string to capitalize
 *
 * @returns {String} The capitalized string
 */
export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
